'use strict';

angular.module('uniromaLandingApp')
    .controller('RejectedRowDetailController', 
    		['$scope', '$rootScope', '$stateParams', 'entity', 'RejectedRow', 'RejectedType', 
    		function($scope, $rootScope, $stateParams, entity, RejectedRow, RejectedType) {
        $scope.rejectedRow = entity;
        $scope.next = null;
        $scope.prev = null;
        $scope.load = function (id) {
        	console.log("ID:"+id);
            RejectedRow.prev({id: id}, function(result) {
                $scope.prev = result;
            });
            RejectedRow.next({id: id}, function(result) {
                $scope.next = result;
            });
        };
        $rootScope.$on('uniromaLandingApp:rejectedRowUpdate', function(event, result) {
            $scope.rejectedRow = result;
        });
        entity.$promise.then(function(){
        	$scope.load(entity.id);
        });
        
    }]);
